"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Adds support for callCC.
 *
 * This module is a Node plugin. In addition, it can be applied from the
 * command line:
 *
 * node built/src/callcc/callcc <filename.js>
 */
const arrowFunctions = require('babel-plugin-transform-es2015-arrow-functions');
const desugarLoop = require("./desugarLoop");
const desugarLabel = require("./desugarLabel");
const desugarSwitch = require("./desugarSwitch");
const desugarLogical = require("./desugarLogical");
const singleVarDecls = require("./singleVarDecls");
const makeBlocks = require("./makeBlockStmt");
const anf = require("./anf");
const nameExprs = require("./nameExprs");
const jumperizeTry_1 = require("./jumperizeTry");
const freeIds = require("./freeIds");
const cleanup_1 = require("./cleanup");
const h = require("@stopify/util");
const generic_1 = require("./generic");
const visitor = {
    Program(path, state) {
        let nameReturns = typeof state.opts.nameReturns === 'boolean' ? state.opts.nameReturns : false;
        generic_1.timeSlow('cleanup arguments.callee', () => h.transformFromAst(path, [cleanup_1.default]));
        generic_1.timeSlow('arrow functions', () => h.transformFromAst(path, [arrowFunctions]));
        generic_1.timeSlow('singleVarDecl', () => h.transformFromAst(path, [[singleVarDecls]]));
        generic_1.timeSlow('free ID initialization', () => freeIds.annotate(path));
        generic_1.timeSlow('desugaring passes', () => h.transformFromAst(path, [makeBlocks, desugarLoop, desugarLabel, desugarSwitch, nameExprs,
            jumperizeTry_1.default, nameExprs]));
        generic_1.timeSlow('desugar logical', () => h.transformFromAst(path, [desugarLogical]));
        generic_1.timeSlow('ANF', () => h.transformFromAst(path, [[anf, { nameReturns: nameReturns }]]));
        path.stop();
    }
};
function default_1() {
    return { visitor };
}
exports.default = default_1;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2FsbGNjLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdHMvY2FsbGNjLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUE7Ozs7Ozs7R0FPRztBQUNILE1BQU0sY0FBYyxHQUFHLE9BQU8sQ0FBQywrQ0FBK0MsQ0FBQyxDQUFDO0FBQ2hGLDZDQUE2QztBQUM3QywrQ0FBK0M7QUFDL0MsaURBQWlEO0FBQ2pELG1EQUFtRDtBQUNuRCxtREFBbUQ7QUFDbkQsOENBQThDO0FBQzlDLDZCQUE2QjtBQUM3Qix5Q0FBeUM7QUFDekMsaURBQTBDO0FBQzFDLHFDQUFxQztBQUNyQyx1Q0FBZ0M7QUFDaEMsbUNBQW1DO0FBR25DLHVDQUFxQztBQUVyQyxNQUFNLE9BQU8sR0FBWTtJQUN2QixPQUFPLENBQUMsSUFBeUIsRUFBRSxLQUFLO1FBQ3RDLElBQUksV0FBVyxHQUFHLE9BQU8sS0FBSyxDQUFDLElBQUksQ0FBQyxXQUFXLEtBQUssU0FBUyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDO1FBQy9GLGtCQUFRLENBQUMsMEJBQTBCLEVBQUUsR0FBRyxFQUFFLENBQ3hDLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxpQkFBTyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBR3ZDLGtCQUFRLENBQUMsaUJBQWlCLEVBQUUsR0FBRyxFQUFFLENBQy9CLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDOUMsa0JBQVEsQ0FBQyxlQUFlLEVBQUUsR0FBRyxFQUFFLENBQzdCLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLGNBQWMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ2hELGtCQUFRLENBQUMsd0JBQXdCLEVBQUUsR0FBRyxFQUFFLENBQ3RDLE9BQU8sQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQztRQUMxQixrQkFBUSxDQUFDLG1CQUFtQixFQUFFLEdBQUcsRUFBRSxDQUNqQyxDQUFDLENBQUMsZ0JBQWdCLENBQUMsSUFBSSxFQUNyQixDQUFDLFVBQVUsRUFBRSxXQUFXLEVBQUUsWUFBWSxFQUFFLGFBQWEsRUFBRSxTQUFTO1lBQy9ELHNCQUFZLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ2hDLGtCQUFRLENBQUMsaUJBQWlCLEVBQUUsR0FBRyxFQUFFLENBQy9CLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLENBQUM7UUFDOUMsa0JBQVEsQ0FBQyxLQUFLLEVBQUUsR0FBRyxFQUFFLENBQ25CLENBQUMsQ0FBQyxnQkFBZ0IsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxDQUFDLEdBQUcsRUFBRSxFQUFFLFdBQVcsRUFBRSxXQUFXLEVBQUUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBRW5FLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUNkLENBQUM7Q0FDRixDQUFDO0FBRUY7SUFDRSxPQUFPLEVBQUUsT0FBTyxFQUFFLENBQUM7QUFDckIsQ0FBQztBQUZELDRCQUVDIn0=


//////////////////
// WEBPACK FOOTER
// ../normalize-js/dist/ts/callcc.js
// module id = 320
// module chunks = 0